import {createContext} from "react";

export interface LayoutContextState {
    changeTitle: ((title: string) => void) | undefined;
}

export const LayoutContext = createContext<LayoutContextState>({ changeTitle: undefined});